import * as z from "zod";
import { requiredString } from "components/form/utils";

export const techStackSchema = z.object({
  name: requiredString(),
  type: requiredString(),
});
